import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../types'

const purchasedItems = (state: RootState) => state.purchasedItems

export const selectLoading = createSelector(
  purchasedItems,
  (state) => state.loading
)

export const selectItemsList = createSelector(
  purchasedItems,
  (state) => state.itemsList
)

export const selectQueryParams = createSelector(
  purchasedItems,
  (state) => state.query
)

export const selectTotalPages = createSelector(
  purchasedItems,
  (state) => state.totalPages
)

export const selectFirstRender = createSelector(
  purchasedItems,
  (state) => state.firstRender
)

export const selectNeedApply = createSelector(
  purchasedItems,
  (state) => state.needApply
)

export const selectSearchText = createSelector(
  purchasedItems,
  (state) => state.searchText
)

export const selectSearchQuery = createSelector(
  purchasedItems,
  (state) => state.searchQuery
)

export const selectIsFilterCollapsed = createSelector(
  purchasedItems,
  (state) => state.isFilterCollapsed
)

export const selectError = createSelector(
  purchasedItems,
  (state) => state.error
)

export const selectCategories = createSelector(
  purchasedItems,
  (state) => state.categories
)

export const selectNonprofits = createSelector(
  purchasedItems,
  (state) => state.nonprofits
)
